import { Language } from '^/types';

export default {
  outside: {
    [Language.KO_KR]: ['좌표가 경계를 벗어납니다'],
    [Language.EN_US]: ['Coordinates are outside of boundary'],
  },
};
